import {
  IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN,
} from "utils/globalConsts";
import checkCurrDomainIsOrgDomain from "./checkCurrDomainIsOrgDomain";

const customDomainPages = [
  "home",
  "inbox",
  "login",
  "user", // all user profile pages
  "create-form", // edit JUMBOform
  "/page/", // personal JUMBOpage
  "invite", // Invitation pages
  "sub-user-complete", // Invitation pages
  "gallery",
  "collection",
  "/j/", // share short link
  "/upload/",
  "/form/",
  "order-tracker",
  "page-edit",
  "picker-success",
  "password-recover",
  "registration-complete",
  "user-confirmation",
];

const isCustomDomainPage = (): boolean => {
  const isCustomDomain = checkCurrDomainIsOrgDomain()

  const pathName = window.location.pathname;

  return (
    (isCustomDomain ||
      (IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN &&
        window.location.hostname === "localhost")) &&
    customDomainPages.some((customPage) => pathName.includes(customPage))
  );
};

export default isCustomDomainPage;
